import React, { useState, useEffect } from "react";
import NewsCard from "../../molecules/NewsCard";
import { getAllNews } from "../../../utils/API/getallnews";
import ProjectListLoader from "../../atoms/ProjectListLoader";
import { LoadingOutlined } from "@ant-design/icons";
const NewsFeed = () => {
  const [newsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newsNotFound, setNewsNotFound] = useState(false);
  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await getAllNews();
        if (response.data)
        {
          setNewsData(response.data);
        }
        else{
          setNewsNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const truncateText = (text, length) => {
    if (text.length <= length) {
      return text;
    }
    return text.substring(0, length) + "...";
  };

  return (
    <div className="mb-5 capitalize bg-white rounded-[10px_0px_0px_0px] border w-[290px] mr-2">
      <div className="pt-3 pb-3">
        <p className="text-center text-[#252525] text-xl font-bold">NEWS</p>
      </div>
      <hr className="w-full h-[0.5px] bg-[#808080] mb-2"></hr>
      {newsNotFound && (
        <div className="text-sm flex gap-2 py-4 font-semibold text-red-500 justify-center">
          <LoadingOutlined />
          <p>Data not found !!</p>
        </div>
      )}
      <div className="h-[1050px] overflow-y-scroll overflow-x-hidden">
      {loading ? (
        <ProjectListLoader />
      ) : (
        newsData?.map(
          ({ _id, description, main_heading_title, cover_img_src }) => (
            <NewsCard
              key={_id}
              id={_id}
              newsTitle={truncateText(main_heading_title, 60)}
              imgSrc={cover_img_src}
            />
          )
        )
      )}
      </div>
    </div>
  );
};

export default NewsFeed;
